import { IInputNode, DateTimeQuestionNode } from '../../../actionCard'

export class DateQuestionNode extends DateTimeQuestionNode implements IInputNode<Date | undefined> {
  public stringifyValue(): string {
    const value = this.getValue()
    return !value || isNaN(value.getTime()) ? '' : value.toLocaleDateString()
  }

  protected override __getStringValue(value?: Date): string | undefined {
    return value ? value.toISOString().substring(0, 10) : undefined
  }
}
